export default "__VITE_ASSET__C3TSMge9__"